import { Globals } from "../CoreApp/Globals";

export function LookupHeight(fontString) {
  if (Globals._textHeightCache == null) Globals._textHeightCache = new Map();

  return Globals._textHeightCache.get(fontString) ?? null;
}
